/**
 * https://www.pdftron.com/api/web/Core.AnnotationManager.html#getSelectedAnnotations__anchor
 */
export default () => window.documentViewer.getAnnotationManager().getSelectedAnnotations();
